export const gateway = "https://standard-bms-api.link.wawanesalife.com";
export const LoginUrlParameter = "https://stable-brokers.auth.ca-central-1.amazoncognito.com/login?client_id=12v7hhmr57ekusjq7mjlr8cseo&response_type=token&scope=email+openid&redirect_uri=https%3A%2F%2Fstandard-bms.link.wawanesalife.com%2Fredirect";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/wawanesalife";
export const HasLinkAdmin = "no";
export const BrokerPoolClientParameter = "12v7hhmr57ekusjq7mjlr8cseo";
export const BrokerPoolDomainParameter = "stable-brokers";
export const BrokerPoolParameter = "ca-central-1_smmgFhHsy";

export const TopMenuLink1Caption = "Wawanesa Life";
export const TopMenuLink1Url = "https://www.wawanesalife.com";
export const TopMenuLink2Caption = "QuickTerm quoter";
export const TopMenuLink2Url = "https://standard.link.wawanesalife.com";

//updated on Thu Sep 11 2025 00:55:44 GMT+0000 (Coordinated Universal Time)
